// extracted by mini-css-extract-plugin
export default {"content_grid":"Footer_content_grid__7ffWa","address":"Footer_address__-Hboq","signup":"Footer_signup__6IRQb","socials":"Footer_socials__gSobO"};